var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mod-simple-pagination"},[_c('a-button',{attrs:{"size":_vm.size,"disabled":_vm.disabled || _vm.current === 1,"icon":"left"},on:{"click":_vm.onPrev}}),_c('a-button',{attrs:{"size":_vm.size,"disabled":_vm.disabled || _vm.total === _vm.current,"icon":"right"},on:{"click":_vm.onNext}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }